import SymptomsBoxInfo from "./SymptomsBoxInfo";

export default SymptomsBoxInfo;